module.exports = __webpack_public_path__ + "Amitprem-3916b35b.webp";